export default Object.freeze({
  byType: [],
  activeIncidentReportsGroupedByType: [],
  incidentReportsGroupedByDateAndType: [],
  incidentReportsGroupedByDate: [],
  loading: true,
});
